/** @license @dairyfarm/eval-web v3.0.0
* Copyright 2020 Texas A&M Center for Applied Technology, 
* Texas A&M Engineering Experiment Station, The Texas A&M 
* University System.
* 
* This source code/schema and any derivative work is Texas 
* A&M Engineering Experiment Station intellectual property 
* and protected by copyright law. Usage is restricted solely 
* to the FARM Animal Care and Environmental Stewardship 
* programs administered by the National Milk Producers 
* Federation. Dissemination of this source code and/or 
* derivative work creation is strictly prohibited without 
* express written permission from the Texas A&M Engineering 
* Experiment Station.
*/
import moment from "moment";
import { createSelector, createSelectorCreator, defaultMemoize } from "reselect";
import { Evaluation } from "../../evaluation";
import { AppState } from "../../redux";

// Custom selector creator uses same memoization tactic but
// only causes render if hashcode of Map is different from previous
// state
export const selectEvals = createSelectorCreator(defaultMemoize, (a: any, b: any) => a.equals(b))(
  (state: AppState) => {
    return state.evals.items;
  },
  evals =>
    evals
      .reduce<Evaluation[]>((arr, evl) => [...arr, evl], [])
      .sort((a, b) => moment(b.modified).diff(moment(a.modified)))
      .map(evl => evl.id)
);

export const selectUserId = createSelector(
  (state: AppState) => state.session.dfdmToken!.sub,
  id => id
);
